var widgetDetails = {
    smart_widgets: [
        {
            name: "Best Sellers",
            id: "85e8e1010e821c634165",
        },
    ]
};

var TagalysCustomisations = {};

TagalysCustomisations.setTagalysConfiguration = function(currencyCode, currencyLabel, baseCountryCode, countryCode) {
    Tagalys.setConfiguration({
        api: {
            serverUrl: "https://api-r4.tagalys.com",
            credentials: {
                clientCode: "4DA7235B27F4357E",
                apiKey: "2de5a22e91c346b28c59588f9c8e8a9b",
            },
            storeId: "14798488",
        },
        platform: "Shopify",
        locale: "en-GB",
        currency: {
            displayFormatter: "{{currencyLabel}}{{value}}",
            code: currencyCode,
            label: currencyLabel,
            fractionalDigits: 2,
            forceFractionalDigits: true,
        },
        baseCountryCode: baseCountryCode,
        countryCode: countryCode,
        platformVariables: {
            useStoreFrontAPIForProductPrices: true, // Set this to true, for displaying product prices based on the configured country code
            storeFrontAPIAccessToken: "d591977e3afa35d044a5ed2dffe7dfd7",
            myShopifyDomain: "percival-menswear.myshopify.com" // ex: {shop}.myshopify.com
        },
        analyticsStorageConsentProvided: function() {
            // return true/false based on user's consent settings
            return true
        },
        track: true
    })
}

TagalysCustomisations.initSearchSuggestions = function () {
    Tagalys.UIWidgets.SearchSuggestions.init(["input#q-1", "input#q-2"], {
        searchResultsURL: "https://www.percivalclo.com/pages/search",
        templates: {
            widget: {
                options: {
                    minimumCharactersToShowSuggestions: 0,
                    alignToSelector: "div.search-suggestions-wrapper",
                },
            },
            // hint: {
            //     render: function (html, args) {
            //         var search_suggestions = document.getElementById('search-suggestions-json');
            //         var search_suggestions_json = JSON.parse(search_suggestions.innerHTML);
            //         return html`
            //             <div class="hints">
            //                 <span class="title">Popular Searches</span>
            //                 <ul>
            //                     ${search_suggestions_json.suggested_links.map((item, index) => {
            //                         return html`
            //                             <li><a href="${item.link}">${item.title}</a></li>
            //                         `;
            //                     })}
            //                 </ul>
            //             </div>
            //         `;
            //     },
            // },
            products: {
                render: function (html, args) {
                    var props = args.props;
                    var products = props.helpers.getProducts();
                    var searchTerm = props.helpers.getEnteredSearchQuery();
                    var search_suggestions = document.getElementById('search-suggestions-json');
                    var search_suggestions_json = JSON.parse(search_suggestions.innerHTML);
                    return html`
                        <div class="suggestions-wrapper">
                            <div class="suggestions-wrapper__top">
                                <div class="hints">
                                    <span class="title">Popular Searches</span>
                                    <ul>
                                        ${search_suggestions_json.suggested_links.map((item, index) => {
                                            return html`
                                                <li><a href="${item.link}">${item.title}</a></li>
                                            `;
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div class="suggestions-wrapper__bottom">
                                <div class="product-results">
                                    <div class=${`products ${props.className}`}>
                                        ${products.map((product, index) => {
                                            return html`
                                                <${args.templates.product} key=${product.id} product=${product} />
                                            `;
                                        })}
                                    </div>
                                    <div class="product-suggestions__view-all">
                                        <a class="btn" href="/pages/search?q=${searchTerm}">View All <svg version="1.1" id="arrow-right" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 24.8 18.7" xml:space="preserve"><path d="M19.9 8H.4v2.6h19.5L12 18.3h3.4l8.9-9-8.9-9H12L19.9 8z" fill="#fff"/></svg></a>
                                    </div>
                                </div>
                                <div class="sidebar">
                                    <span class="heading with-border">Useful Pages</span>
                                    <div class="sidebar__pages">
                                        <ul>
                                        ${search_suggestions_json.pages.map((item, index) => {
                                            return html`
                                                <li><a href="${item.link}">${item.title}</a></li>
                                            `;
                                        })}
                                        </ul>
                                    </div>
                                    <span class="heading">Featured</span>
                                    <div class="sidebar__articles">
                                        ${search_suggestions_json.articles.map((item, index) => {
                                            return html`
                                                <div class="block">
                                                    <a href="${item.link}" title="${item.title}">
                                                        <div class="image-wrapper">
                                                            <img class="lazy" src="${item.image}" alt="${item.title}" />
                                                        </div>
                                                        <span class="title">${item.title}</span>
                                                    </a>
                                                </div>
                                            `;
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
                },
            },
        },
    });
};

TagalysCustomisations.initSearchResults = function () {
    Tagalys.UIWidgets.SearchResults.init("div.search-results-container", {
        templates: {
            header: {
                render: function (html, args) {
                    return html`<div class="plp-header"><span class="plp-subheader">Search Results</span><${args.templates.heading} /></div>`;
                },
            },
            noResults: {
                options: {
                    widgets: [
                        { widgetId: widgetDetails.smart_widgets[0].id },
                    ],
                },
                render: function (html, args) {
                    var labels = args.labels
                    return html`
                        <div class="no-results">
                            <div class="no-results-wrapper">
                                <h1 class="no-results-heading">Search Results</h1>
                                <span class="no-results-subheading">${labels.searchResults.noResultsHeading}</span>
                            </div>
                            <${args.templates.noResultsWidgets} />
                        </div>
                    `;
                },
            },
        },
    });
};